import type { WorkToastItem } from "@/stores/work-toast-store";
import { isComputerWorkToastPinned } from "./work-toast-computer-pin";

export const LIVE_WORK_TOAST_CREATED_EVENT = "denker:live-work-toast-created";

let armed = false;
const seenOccurrences = new Set<string>();

function occurrence(item: WorkToastItem): string {
  const stateIdentity =
    item.state === "question"
      ? item.question?.awaitingInputId
      : item.state === "approval"
        ? item.approval?.approvalId
        : item.answerDelivery?.status ?? null;
  return `${item.key}:${item.state}:${stateIdentity ?? ""}:${isComputerWorkToastPinned(item) ? "computer" : ""}`;
}

function seed(items: Record<string, WorkToastItem>) {
  Object.values(items).forEach((item) => seenOccurrences.add(occurrence(item)));
}

export function resetWorkToastAutoOpen(items: Record<string, WorkToastItem>) {
  seenOccurrences.clear();
  disarmWorkToastAutoOpen(items);
}

export function disarmWorkToastAutoOpen(items: Record<string, WorkToastItem>) {
  armed = false;
  seed(items);
}

export function armWorkToastAutoOpen(items: Record<string, WorkToastItem>) {
  seed(items);
  armed = true;
}

export function observeLiveWorkToastCreation(
  before: Record<string, WorkToastItem>,
  after: Record<string, WorkToastItem>,
) {
  seed(before);
  const created = Object.values(after)
    .filter((item) => !seenOccurrences.has(occurrence(item)) && !item.dismissed)
    .sort((a, b) => b.stateChangedAt - a.stateChangedAt)[0];
  seed(after);
  if (!armed || !created || typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<WorkToastItem>(LIVE_WORK_TOAST_CREATED_EVENT, {
      detail: created,
    }),
  );
}
